module.exports = __webpack_public_path__ + "img/active_black.094999a2.png";